import React from 'react'
import { useTranslation } from 'react-i18next'

import AccountSwitcherModal from './AccountSwitcherModal'
import { useAccountSwitcher } from './useAccountSwitcher'
import { getAccountInitials } from './accountAvatar'
import { ChevronsUpDownIcon } from 'images'

/**
 * Mobile counterpart to AccountSwitcher.jsx — same trigger + modal, but built
 * on .mobile-nav__link instead of .main-nav's row/label-slot markup, since the
 * mobile drawer has no collapse/expand state (it's always "expanded"): the
 * label and chevron are just always shown, no fade/width animation needed.
 */
const AccountSwitcherMobile = () => {
  const { t } = useTranslation()
  const { partnerId, hasMultipleAccounts, showModal, setShowModal, switchingAccountId, selectAccount } =
    useAccountSwitcher()

  if (!hasMultipleAccounts) return null

  return (
    <li id="mobile-nav-item-account-switcher">
      <button
        type="button"
        className="mobile-nav__link account-switcher__trigger w-100"
        onClick={() => setShowModal(true)}
        title={partnerId}
        aria-label={t('AccountSwitcher.trigger')}
      >
        <span className="account-switcher__avatar" aria-hidden="true">
          {getAccountInitials(partnerId)}
        </span>

        <span style={{ marginTop: 2, paddingTop: 0 }} className="mobile-nav__link__label">
          {partnerId}
        </span>

        <ChevronsUpDownIcon
          width={16}
          height={16}
          className="account-switcher__chevron"
          aria-hidden="true"
        />
      </button>

      <AccountSwitcherModal
        isOpen={showModal}
        currentPartnerId={partnerId}
        switchingAccountId={switchingAccountId}
        onClose={() => setShowModal(false)}
        onSelect={selectAccount}
      />
    </li>
  )
}

export default AccountSwitcherMobile
